import { FocusGraph } from "@/components";
import RuleGraphProvider from "@/components/GraphVisualisation/providers/RuleGraphProvider";
import { releaseDecisionGraph } from "@imminently/decisively-core";
import styled from "@emotion/styled";

export const AttributeGraph = ({ attribute, release }) => {
  const StyledFocusGraph = styled(FocusGraph)`
    height: 100%;
  `;

  return (
    <RuleGraphProvider graph={releaseDecisionGraph(release)}>
      <StyledFocusGraph graph={release.rule_graph} focusNode={attribute} />
    </RuleGraphProvider>
  )
}
